import React  from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import Text from '@dbk/ui-text';
import {Currency } from '../../components/common/number';
import styles from './summary-header-styles';

/* Summary Total Market Value Header */
function SummaryHeader({
    messages,
    prefCurrency,
    mktValueTotal,
    asOfDate
}){

    return(
        <div>
             <div className = "summary-header">
            {messages['app.dashboard.summaryData.title']}{asOfDate}
            </div>
      <div className = "summary-header-value">
            <Currency
                    signBeforeNumber={false}
                    decimalStyle={styles.decimelStyle}
                    currencyStyle = {styles.currencyStyle}
                    currency={prefCurrency}
                    renderProps={{
                        style: styles.marketTotalHeaderNomination,
                        size: 40
                    }}
                    value={mktValueTotal}
                />
            {/* <Text className = "summary-header-currency">{prefCurrency}</Text> */}
            </div>
            <div className = "summary-header-total">
            {messages['app.dashboard.summaryData.marketValue.total.title']}
            </div> 
            </div>
    );

}
   
SummaryHeader.propTypes = {
    mktValueTotal: PropTypes.number,
    prefCurrency: PropTypes.string,
  };
  
  
export default pure(SummaryHeader);